;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { buildQueryParams } from '@workspace/ui/lib';
import type { ApiResponse } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';
import type { EmployeeResponse } from '@/types/employees';

export const getEmployeeByUserAndOrganisation = async (
  user_id: number,
  organisation_id: number,
  team_id?: number
): Promise<ApiResponse<EmployeeResponse>> => {
  const queryParams = buildQueryParams({ user_id, organisation_id, team_id });
  const apiUrl = process.env.NEXT_PUBLIC_EOR_API_URL;

  if (!apiUrl) {
    throw new Error('[getEmployeeByUserAndOrganisation] NEXT_PUBLIC_EOR_API_URL is not set');
  }

  const response = await fetchAPI<EmployeeResponse>(
    `${apiUrl}/seats/by-user-and-organisation?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );

  if (!response.success) {
    throw new Error(
      response.error || response.message || 'Failed to fetch employee by user and organisation'
    );
  }

  return {
    ...response,
    message: response.message || 'Employee by user and organisation fetched successfully',
  };
};
